import { render, staticRenderFns } from "./ButtonAddToFolder.vue?vue&type=template&id=09a2ed44&"
import script from "./ButtonAddToFolder.vue?vue&type=script&lang=ts&"
export * from "./ButtonAddToFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports